// extracted by mini-css-extract-plugin
export default {"pageWrap":"kb-z","fullWidth":"lb-z","heading":"mb-z","fullBleed":"nb-z","hidden":"ob-z"};